// todo change to enum, like clients.ts (note: changes in sv-magic-backoffice project; doublecheck for sv-magic-frontend (monitoring))
export const ADMIN_ROLE = "admin";
export const GUEST_ROLE = "guest";
export const OPERATOR_ROLE = "operator";
export const HOUSEKEEPER_ROLE = "house-keeper";
export const BREAKFAST_OPERATOR_ROLE = "breakfast-operator";
export const HOST_ROLE = "host";
